import { ADULT_MIN_AGE } from 'src/services/mappings/person/person.const'
import { getAge } from 'src/utils/getAge'

export function getPersonAge(record: Record<string, unknown>) {
  if (!record.dateOfBirth) {
    // consider as adult
    return ADULT_MIN_AGE
  }

  return getAge(record.dateOfBirth as string)
}

export function safeParseInt(value: unknown, defaultValue = 0): number {
  const parsedValue = Number.parseInt(value as string)

  if (Number.isNaN(parsedValue)) return defaultValue

  return parsedValue || 0
}

export function safeParseFloat(value: unknown, defaultValue = 0): number {
  const parsedValue = Number.parseFloat(value as string)

  if (Number.isNaN(parsedValue)) return defaultValue

  return parsedValue || 0
}
